/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, NamedResourceTagFromJSON, NamedResourceTagToJSON, OrganisationListEntryFromJSON, OrganisationListEntryToJSON, UserListEntryFromJSON, UserListEntryToJSON, } from './';
export function AccessGrantListEntryFromJSON(json) {
    return AccessGrantListEntryFromJSONTyped(json, false);
}
export function AccessGrantListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fromOrganisation': OrganisationListEntryFromJSON(json['fromOrganisation']),
        'toUser': !exists(json, 'toUser') ? undefined : UserListEntryFromJSON(json['toUser']),
        'toOrganisation': !exists(json, 'toOrganisation') ? undefined : OrganisationListEntryFromJSON(json['toOrganisation'])
    };
}
export function AccessGrantListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metaData': MetaDataToJSON(value.metaData),
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'id': value.id,
        'fromOrganisation': OrganisationListEntryToJSON(value.fromOrganisation),
        'toUser': UserListEntryToJSON(value.toUser),
        'toOrganisation': OrganisationListEntryToJSON(value.toOrganisation)
    };
}
